import { Trans } from '@lyearn/i18n';

import fieldValidate from '../../helper/fieldValidate';
import {
  Field,
  FieldType,
  FieldValidationFunction,
  FieldValidationTypes,
  FormPicklistField,
} from '../../types';
import Input from '../picklist/Input';
import { FieldInputType } from '../types';

const fieldValidation: FieldValidationFunction<string[]> = {
  [FieldValidationTypes.Required]: ({ value, validation }) => {
    if (!value || !value?.length) {
      return validation?.message || <Trans i18nKey="Form:FieldRequiredMessage" />;
    }
  },
  [FieldValidationTypes.Custom]: () => undefined,
};

const MultiPicklistInputField: FieldInputType<FormPicklistField, string[]> = {
  Input,
  type: FieldType.MultiPicklist,
  validate: (field, value, values) => {
    return fieldValidate({ field, value, values, fieldValidation });
  },
};

export default MultiPicklistInputField;
